import styled from "styled-components";
export const InvoiceItemWrapper = styled.div`
  .invoice {
    @media (max-width: 567px) {
      p {
        font-size: 12px;
      }
      button {
        font-size: 12px;
      }
    }
  }
`;
